import {sprintf} from 'sprintf-js';

export function isAdmin(user) {
    return user.is_admin
}

export function isPaperSession(session) {
    return session.type === 'Paper';
}

export function isCustomSession(session) {
    return session.type === 'Custom';
}

export function isSpecialSession(session) {
    return !new Set(['Paper', 'Break']).has(session.type);
}

export function isBreakSession(session) {
    return session.type === 'Break';
}

/**
 * Converts time as HH:mm:ss into seconds. Inspired by https://techstream.org/Bits/Javascript/Javascript-Parse-time
 * @param timeString String containing HH:mm:ss time format
 */
export function timeStringToSeconds(timeString) {

    const pieces = timeString.split(':');
    const hour = parseInt(pieces[0]);
    let timeString2=null;
    let extra_seconds = 0;
    if (hour>23) {

        pieces[0] = '0' + (hour - 24).toString();
        timeString2=pieces.join(":");
        extra_seconds = 24*3600;

    } else {
        timeString2 = timeString;
    }

    const date = new Date('1970-01-01T' + timeString2);
    return (date.getHours() * 60 * 60) + (date.getMinutes() * 60) + date.getSeconds() +extra_seconds;
}

/**
 * Converts seconds into time as HH:mm:ss
 * @param seconds Integer amount of seconds
 */
export function secondsToTimeString(seconds) {

    let remainderSeconds = seconds % 60;
    let minute = Math.floor(seconds / 60) % 60;
    let hour = Math.floor(seconds / 3600) % 24;

    return sprintf('%02d:%02d:%02d', hour, minute, remainderSeconds);
}

/**
 * Filters sessions according to current text input
 * @param filterText
 * @param sessions
 */
export function filterSessions(filterText, sessions) {
    const text = filterText.toLowerCase().trim();

    /* Here is where the filtering is done based on the user input */
    return sessions.filter((session) => {
        if (text === '') return true;

        let kws_in_papers = '';
        let track_in_papers = '';
        if (isPaperSession(session)) {
            const seenKeywords = new Set();
            const seenTracks = new Set();
            for (let paper of session.papers) {
                for (let kw of paper.keywords) {
                    if (seenKeywords.has(kw.code)) continue;
                    seenKeywords.add(kw.code);
                    kws_in_papers += kw.code.toLowerCase() + ' ';
                }
                if (!seenTracks.has(paper.track.name)) {
                    seenTracks.add(paper.track.name)
                    track_in_papers += paper.track.name + ' ';
                }
            }
        }
        return session.data.name.toLowerCase().includes(text) || kws_in_papers.includes(text) || track_in_papers.toLowerCase().includes(text);
    });
}
